<script>
  import Select from "../components/HTMLElements/Select.svelte";
  //import SchoolPicker from "../components/Utils/SchoolPicker.svelte";
  import { onMount, afterUpdate } from "svelte";
  import * as utils from "../components/Utils/utils.js";
  import * as animateScroll from "svelte-scrollto";
  import {ContactBoroughs} from '../store.js'
  import Help from '../components/help.svelte'
  import  wrappedFetch from  '../wrappedFetch.js';
  let isMobile = utils.isMobileDevice();

  const handleResize = () => {
    isMobile = utils.isMobileDevice();
  };

  let selectedLocalAuthority,
    selectedPhase = undefined;
  let laList = [];
  let phases = [];
  let details;
  let showDetails = false;
  let showPhase = false;
  let address = [];
  let logopath = "";
  let errorTextRed = false;
  //onMount(async function() {

    if ($ContactBoroughs.length <=0)
    wrappedFetch("borough/GetBoroughs?isAdmitting=true")
      .then(res => res.json())
      .then(result => {
        laList = result;
        laList.forEach((data, key) => {
          laList[key]["label"] = data.name;
        });
        ContactBoroughs.set(laList)
      });
  //});

  afterUpdate(() => {
    if (isMobile && showDetails) { 

       animateScroll.scrollTo({element: '#detailsContainer'})
      
    }
  });

  const handleSelectSecondList = item => {

  };
  let handleSelectPhase = phase => {   
      showDetails = false;
      if(phase!="")
      {
    wrappedFetch(
      "borough/detailswithphase?laid=" +
        selectedLocalAuthority.id +
        "&phase=" +
        phase.id + "&x=" + new Date().getTime()
    )
      .then(response => response.json())
      .then(result => {
        details = result;
        details.address = Array.from(details.address.split(","));
        if (
          details.url != "" &&
          !details.url.startsWith("http://") &&
          !details.url.startsWith("https://")
        )
          details.url = "http://" + details.url;
        logopath = "images/logos/logo_" + selectedLocalAuthority.id + ".jpg";
        showDetails = true;
      });
  }
  };

  let handleSelectLocalAuthority = selectedAuthority => {
    showDetails = false;
    if (selectedAuthority === "") {
      showPhase = false;
      phases = [];
    } else {
      wrappedFetch("borough/getavailphases?laid=" + selectedAuthority.id)
        .then(res => res.json())
        .then(result => {
          phases = result;
          phases.forEach((phase, key) => {
            phases[key]["label"] = phase.name;
          });
          showPhase = true;
        });
    }
    selectedPhase = "";
  };
</script>

<svelte:head>
  <title>Local Authority Details | eAdmissions</title>
</svelte:head>
<svelte:window on:resize={handleResize} />
<section class="section">
  <div class="container">
     <div class="field">
              <a href="/">
                <span class="fas fa-arrow-left" />
                Back
              </a>
            </div>
    <div class="tile">
  
      <div
        id="selectionContainer"
        class="tile notification is-primary is-vertical is-5 contact-container-left"
        style=" margin-bottom:0px;">
        <h1 class="title">Local Authority Details</h1>
        <p class="subtitle is-6">
          Please select a local authority and phase below.
        </p>

        <div class="field">
          <div class="">
            <label for="" class="label" style="color:white;">
              Select a Local Authority
            </label>
            <div>
              <Select
                items={$ContactBoroughs}
                bind:selected={selectedLocalAuthority}
                placeholder="--- Please select ---"
                on:change={handleSelectLocalAuthority(selectedLocalAuthority)} 
                {errorTextRed}
                label="a Local Authority"/>

            </div>
          </div>
        </div>
        
          <div class="field">
            <div >
              <label for="" class="label" style="color:white;">
                and then select a phase
              </label>
              <div >
                <Select
                  items={phases}
                  bind:selected={selectedPhase}
                  placeholder="--- Please select ---"
                  on:change={handleSelectPhase(selectedPhase)} 
                  {errorTextRed}
                  label="a phase"/>
              </div>
            </div>
          </div>
        
        <hr />
        <!-- <SchoolPicker secondItemListName="school" searchOption={true} on:handleSelectSecondList={handleSelectSecondList}/>
        <hr />-->
        <Help helpId='Help45' isPage={false}/>
      </div>
      {#if showDetails}
        <div id="detailsContainer"
          class="tile is-vertical contact-container-right"
          style=" padding: 15px; ">
          <div>
            <a href={details.url} target="_blank"><img src={logopath} alt="council_logo" /></a>
          </div>
          <h4 class="title is-4">
            {details.displayName}
          </h4>
          <div>
            <p style="margin-bottom:0px;">
              <strong>{details.contactName}</strong>
            </p>
            <p>
            {#each details.address as addr}
            {addr}
              <br/>            
              {/each}
            </p>
            Phone: 
            <!-- <span class="fas fa-phone" />  -->
            <a href="tel:{details.phasePhone}">{details.phasePhone}</a>
            <br />
            Email: 
            <!-- <span class="fas fa-envelope" /> -->
            <a href="mailto:{details.phaseEmail}">{details.phaseEmail}</a>
            <br>
            Website:
            <!-- <span class="fas fa-globe" /> -->
            <a href={details.url} target="_blank">{details.url}</a>
            <hr />

            <p>
              <strong>{details.phaseName} admissions</strong>              
               {#if details.start}
               <br />
              Online Application Open Date: {details.start}
              {/if}
               {#if details.stop}
              <br />
              On-Time Closing Date: {details.stop}
              {/if}
              {#if details.showLate == 'Y' && details.lateStop}
              <br />
              Late Closing Date: {details.lateStop}
              {/if}
               {#if details.reveal}
              <br />
              Publication of Outcome Online Date: {details.reveal.split(' ')[0]}
              {/if}
               {#if details.documentStop}
              <br />
              Upload Supporting Documents Deadline Date: {details.documentStop}
              {/if}             
              {#if details.phaseCode == 'N1' && details.startDob}
               <br />
             Date of Birth Range: {details.startDob.split(' ')[0]} - {details.endDob.split(' ')[0]}
               {/if}
            </p>
            <hr />
            <div id="phaseDetails">
              {@html details.infoMessage}
            </div>

          </div>
        </div>
      {/if}
    </div>

  </div>

</section>
